import Analysis from 'models/analysis';
import analysisApi from 'api/analysis';
import AnalysisTabs from 'components/analysisTabs';
import branchApi from 'api/branch';
import customerApi from 'api/customer';
import dealerApi from 'api/dealer';
import debounce from 'lodash/debounce';
import events from 'lib/events';
import getProductDict from 'page/customer/system/productDict';
import Header from 'components/layout/header';
import IntlWrapper from 'components/layout/intlWrapper';
import isEqualWith from 'lodash/isEqualWith';
import Loader from 'components/loader';
import LoadingButton from 'components/loadingBtn';
import moment from 'moment';
import path from 'path';
import poolApi from 'api/pool';
import Popup from 'components/layout/popup';
import productApi from 'api/product';
import PropTypes from 'prop-types';
import React from 'react';
import ReactDOM from 'react-dom';
import router from 'lib/router';
import routeUtils from 'util/routeUtils';
import session from 'services/sessionService';
import throttle from 'lodash/throttle';
import ValidationGroup from 'helpers/validation';
import WaterAnalysis from './waterAnalysis';
import WaterProblems from './waterProblems';
import waterTesterApi from 'api/waterTester';
import partialDrains from './partialDrains';

import {
  chemicalBaseTypeNames,
  chemicalBaseTypes,
  productTypes,
  propertyTypes,
  scanTypes,
  seasonTemperatureOverrides,
  seasonTypes,
  systemTypes,
  winterOxidizers,
} from 'helpers/constants';
import {discTypes, getStripsAvailable, preprocessData, scanDisabledFields, stripTypes} from 'helpers/scanHelpers';
import {FormattedMessage, injectIntl, intlShape} from 'react-intl';
import {
  storeHistory,
  updateHistory,
  getHistory,
  getScanners,
  getCurrentScanner,
  isScanning,
  startAccuscan,
  startSmartLab,
  getResults,
  getAccuscanStrip,
  getAccuscanStrips,
  resetTestConnect,
} from 'services/testConnect';
import {getState} from 'services/testConnectState';
import {isProductTruBlue} from 'helpers/truBlue';
import SuggestedProductsSelection from './SuggestedProductsSelection';
import {suggestedProductsEnabled} from 'features';

let render = (container, params) => {
  console.info('[UI.page.customer] rendering page');
  // Redirects route /analysis/report to /analysis
  if (params.analysisID && Number(params.analysisID).toString() !== params.analysisID) {
    window.location.hash = path.join(window.location.hash, '..');
  } else {
    events.publish('page-change', {page: 'customer'});

    var _id;
    var _contactid;

    if (params.id) {
      _id = parseInt(params.id.split('.')[0]);
      _contactid = parseInt(params.id.split('.').length > 1 ? params.id.split('.')[1] : null);
    }

    ReactDOM.render(
      <IntlWrapper>
        <WrapperScanning
          poolID={params.system}
          customerID={_id}
          contactId={_contactid}
          analysisID={params.analysisID}/>
      </IntlWrapper>,
      container
    );
  }
};

console.info('[UI.page.customer] register route');
router.rr.add([{path: 'customer/:id/:system/analysis', handler: routeUtils.requireAuth(render)}]);
router.rr.add([{path: 'customer/:id/:system/analysis/:analysisID', handler: routeUtils.requireAuth(render)}]);

// Page object
class Scanning extends React.Component {
  static displayName = 'Scanning';

  static propTypes = {
    customerID: PropTypes.number,
    poolID: PropTypes.string,
    analysisID: PropTypes.string,
    scanID: PropTypes.string,
    intl: intlShape.isRequired,
  };

  state = {
    accuscanInstructions: false,
    analysis: new Analysis({}),
    analysisWorkingCopy: new Analysis({}),
    branch: {},
    customer: {
      customerContacts: [],
    },
    dealer: {},
    disabledFields: [],
    edit: true,
    historyId: null,
    isValidating: false,
    loaded: false,
    manualScan: true,
    noScannersFound: false,
    partialDrainAnswered: false,
    partialDrainVisible: false,
    pool: {},
    products: [],
    sanitizerName: '',
    sanitizerType: 0,
    saving: false,
    scanners: ['Manual'],
    isScanning: false,
    scanResetDelay: 0,
    securityError: false,
    selectedScanner: null,
    selectedDisc: discTypes()[0],
    selectedStrips: [],
    testers: [],
  };

  componentWillMount() {
    let {formatMessage} = this.props.intl;

    events.publish('scannerProgress.noClickable');

    this._save = throttle(this.saveAnalysis, 2000, {trailing: false});
    this.group = new ValidationGroup(this._save, this.toggleValidation);

    if (!session.getUser().privileges.canWaterTest) {
      events.publish('error.user', {message: formatMessage({id: 'scanning.error.not.authorized'})});
    }

    // Look for persisted state in session and restore if possible
    this.checkSessionData();

    events.subscribe('scanner.start', () => this.setState({isScanning: true}));
    events.subscribe('scanner.cancel', () => {
      if (this.mounted) {
        this.setState({isScanning: false});
      }
    });
    events.subscribe('scanner.complete', () => {
      setTimeout(() => {
        this.parseScanResults(getState());
      }, 50);
    });
    events.subscribe('testconnect.analysisChanged', () => {
      this.ignoreProps = true;
      this.checkSessionData();
    });

    this.partialDrainCheck = debounce(analysis => this.setState(partialDrains({
      analysis,
      dealer: this.state.dealer || {},
      formatMessage: this.props.intl.formatMessage,
      sanitizerType: this.state.sanitizerType,
      pool: this.state.pool || {},
      products: this.state.products || [],
    })), 750);
  }

  componentDidMount() {
    this.mounted = true;
    this.titrationTestingListener = events.subscribe('dealeruser.toggleTitrationTestingOnly', () => this.initializeScanner());
  }

  componentWillReceiveProps(props) {
    if (!this.ignoreProps) {
      this.props = props;
      // Look for persisted state in session and restore if possible
      let sessionData = session.getAnalysis(this.props.poolID);

      if (sessionData) {
        if (getResults()) {
          let analysisWorkingCopy = preprocessData(getResults(), sessionData.analysisWorkingCopy, this.state.selectedScanner, this.state.sanitizerType);

          sessionData = Object.assign({}, sessionData, {analysisWorkingCopy});
        }
        this.setState(sessionData);
      } else {
        this.fetchData();
      }
    } else {
      this.ignoreProps = false;
    }
  }

  componentWillUnmount() {
    this.mounted = false;

    events.publish('scannerProgress.clickable');
    if (this.shouldPersist) {
      session.persistAnalysis(this.state);
    }
    if (this.titrationTestingListener && this.titrationTestingListener.remove) {
      this.titrationTestingListener.remove();
    }
  }

  checkSessionData = () => {
    let sessionData = session.getAnalysis(this.props.poolID);

    if (!sessionData) {
      this.initializeScanner();
      this.fetchData();
      return;
    }

    if (sessionData.fromHistory) {
      let analysisWorkingCopy = preprocessData(sessionData.initialAnalysis,
        new Analysis(sessionData.analysisWorkingCopy), sessionData.scanner || sessionData.selectedScanner, sessionData.sanitizerType);

      sessionData = Object.assign({}, sessionData, {analysisWorkingCopy});
    } else if (getResults()) {
      let analysisWorkingCopy = preprocessData(getResults(), sessionData.analysisWorkingCopy, sessionData.scanner || sessionData.selectedScanner, sessionData.sanitizerType);

      sessionData = Object.assign({}, sessionData, {analysisWorkingCopy});
    }
    //Reset partial drain
    sessionData.analysis.partialDrain = false;
    sessionData.analysisWorkingCopy.partialDrain = false;
    this.setState(sessionData, () => {
      if (!this.state.isScanning || isScanning()) {
        return;
      }

      this.setState({isScanning: false, disabledFields: []});
    });
  };

  acceptPartialDrain = () => {
    let {formatMessage} = this.props.intl;
    let analysis = this.state.analysisWorkingCopy;

    analysis.partialDrain = true;
    analysisApi.saveAnalysis(analysis)
      .then(a => {
        let pool = session.getPool(a.poolID);

        if (pool) {
          session.deletePool(pool);
        }

        session.forgetAnalysis(this.props.poolID);
        this.shouldPersist = false;

        resetTestConnect(!session.getUser().titrationTestingOnly);


        if (!this.props.analysisID) {
          events.publish('scanner.cancel');
          window.location.hash = path.join(window.location.hash, 'report', a.id.toString());
        } else {
          window.location.hash = path.join(window.location.hash, '..', 'report', a.id.toString());
        }
      })
      .catch(e => {
        console.error(e);
        events.publish('error.user', {message: formatMessage({id: 'scanning.error.saving.analysis'})});
      });
  };

  changeScanner = (data) => {
    this.state.analysisWorkingCopy.scanTypeID = scanTypes[data.target.value];
    this.setState({
      analysisWorkingCopy: this.state.analysisWorkingCopy,
      selectedScanner: data.target.value,
      manualScan: data.target.value === 'Manual',
      accuscanInstructions: data.target.value === 'Accuscan',
    });
  };

  checkPossibleCD = (am) => {
    if (!am.totalBromine && !am.freeChlorine) {
      return false;
    }

    let totalBromine = parseFloat(am.totalBromine);
    let freeChlorine = parseFloat(am.freeChlorine);
    let totalChlorine = parseFloat(am.totalChlorine);

    if (this.state.sanitizerType === chemicalBaseTypes.brominePool) {
      if (totalBromine < 0.5 && (am.season === 'springopening' || this.state.pool.prevPossibleCD)) {
        return true;
      }
    } else if ([chemicalBaseTypes.chlorinePool, chemicalBaseTypes.saltWaterPool].indexOf(this.state.sanitizerType) !== -1) {
      if (freeChlorine < 0.5 && (am.season === 'springopening' || this.state.pool.prevPossibleCD)) {
        return true;
      }
    } else if (this.state.sanitizerType === chemicalBaseTypes.mineralSpringsPool) {
      if (freeChlorine < 0.5 && (am.startup || this.state.pool.prevPossibleCD)) {
        return true;
      }
    }

    //ALEX-789
    //(Limited to the systems that can make a chlorine demand test)
    if ([chemicalBaseTypes.chlorinePool, chemicalBaseTypes.chlorineSpa,
      chemicalBaseTypes.mineralSpringsPool, chemicalBaseTypes.saltWaterPool].indexOf(this.state.sanitizerType) !== -1 &&
      totalChlorine === 0 && freeChlorine === 0) {
      return true;
    }

    return false;
  };

  collapseAnalysis = () => {
    this.setState({collapsedAnalysis: true, collapsedProblems: false});
    if (this.state.isScanning) {
      events.publish('ga.event', {category: 'User', action: 'scan-next-scanning'});
    } else {
      events.publish('ga.event', {category: 'User', action: 'scan-next-done-scanning'});
    }
  };

  collapseProblems = () => {
    this.setState({collapsedAnalysis: false, collapsedProblems: true});
  };

  dataChanged = (e) => {
    let {formatMessage} = this.props.intl;
    let analysis = this.state.analysisWorkingCopy.clone();

    analysis[e.key] = e.value;
    if (e.key === 'season') {
      analysis = this.validateSeasonTemperatureOverrides(analysis);
    }

    this.partialDrainCheck(analysis);

    analysis.possibleCD = this.checkPossibleCD(analysis);
    if (analysis.possibleCD) {
      events.publish('warn.user', {
        message: formatMessage({id: 'scanning.possible.chlorine.demand'}),
        key: 'possibleCD',
        customClass: 'chlorine-demand',
      });
    } else {
      events.publish('cancel.error', {key: 'possibleCD'});
    }

    if (e.key === 'ironStaining' || e.key === 'copperStaining') {
      events.publish('cancel.error', {key: 'winterMetalStaining'});
    }

    if (e.key === 'copper' && analysis.copperFromProduct && (!e.value || e.value <= 0 || e.value >= 1)) {
      analysis.copperFromProduct = false;
    }

    this.setState({analysisWorkingCopy: analysis});
  };

  declinePartialDrain = () => {
    this.setState({partialDrainAnswered: true});
  };

  fetchData = () => {
    let {formatMessage} = this.props.intl;
    let apis = [
      customerApi.getCustomer(this.props.customerID),
      waterTesterApi.getWaterTesters(),
      poolApi.getPool(this.props.poolID),
      productApi.getProducts(),
      dealerApi.getDealer(session.getUser().dealerId),
      analysisApi.getLatest(this.props.poolID),
    ];

    if (this.props.analysisID) {
      apis.push(analysisApi.getAnalysis(this.props.analysisID));
    }

    Promise.all(apis)
      .then(([customer, testers, pool, products, dealer, latestPoolAnalysis, analysis]) => {
        let {productDict, pool: p} = getProductDict({pool: pool.clone(), products, dealer, formatMessage}); // Fixes pools with no products selected or deleted products selected

        // Replace api call with this since track the previous analysis date anyway
        let analysesThisYear = pool.prevAnalysisDate ? pool.prevAnalysisDate.year() === moment().year() : false;

        let season = seasonTypes.inSeason;

        if (p.typeID !== systemTypes.spa) {
          let now = moment();

          pool.seasonStart.year(now.year());
          pool.seasonEnd.year(now.year());

          if (!analysesThisYear &&
            now <= pool.seasonStart.add(dealer.seasonOpenMargin, 'weeks')) {
            season = seasonTypes.opening;
          } else if (now >= pool.seasonEnd.subtract(dealer.seasonEndMargin, 'weeks') &&
            now <= pool.seasonEnd.add(dealer.seasonEndMargin, 'weeks')) {
            season = seasonTypes.closing;
          } else if (analysesThisYear ||
            now >= pool.seasonStart.subtract(dealer.seasonOpenMargin, 'weeks') &&
            now <= pool.seasonEnd.subtract(dealer.seasonEndMargin, 'weeks')) {
            season = seasonTypes.inSeason;
          } else {
            // Bad side of in-season
            season = seasonTypes.closing;
          }

        }

        if (latestPoolAnalysis && latestPoolAnalysis.Season) {
          season = latestPoolAnalysis.Season; // Default to previous
          //Until the date falls into the Spring Opening date range per Season Usage date
          let now = moment();

          if (pool.seasonStart <= now && now <= pool.seasonStart.add(dealer.seasonOpenMargin, 'weeks')) {
            season = seasonTypes.opening;
          }
        }

        var winterizers = products.filter(p => p.productTypeID === productTypes.winterOxidizer);
        var hasDotNotCloseWinterizer = winterizers && winterizers
          .filter(w => w.code === winterOxidizers.doesNotClose && w.id === pool.winterOxidizer).length >= 1;
        // No winter closing for swim spas or  pool systems with 'Does not close' as winterizer

        if ((p.typeID === systemTypes.swimspa || hasDotNotCloseWinterizer) && season === seasonTypes.closing) {
          season = seasonTypes.inSeason;
        }

        let saveToState = poolToSave => {
          let filterCleanedDate = moment().subtract(43, 'days');
          let mSCellCleanedDate = moment().subtract(43, 'days');

          if (poolToSave.filterCleanedDate && poolToSave.filterCleanedDate.isValid()) {
            filterCleanedDate = moment.max(filterCleanedDate, poolToSave.filterCleanedDate);
          }
          if (poolToSave.mSCellCleanedDate && poolToSave.filterCleanedDate.isValid()) {
            mSCellCleanedDate = moment.max(mSCellCleanedDate, poolToSave.mSCellCleanedDate);
          }

          let a = analysis && analysis.id ? analysis : new Analysis({
            testType: '2',
            filterCleanedDate: filterCleanedDate,
            mSCellCleanedDate: mSCellCleanedDate,
            lastCleanedDrained: poolToSave.lastCleanedDrained && poolToSave.lastCleanedDrained.isValid() ?
              poolToSave.lastCleanedDrained : moment().subtract(30, 'days'),
            poolID: this.props.poolID,
            season: season,
            algaeProduct: '40',
            clarifier: dealer.defaultProductHazyWater && dealer.defaultHazyProduct ? dealer.defaultHazyProduct : '60',
            cDProduct: '1173',
            scanTypeID: scanTypes.Manual,
          });

          //Reset partial drain
          a.partialDrain = false;

          a = this.validateSeasonTemperatureOverrides(a);

          testers = testers || [];

          // Add a blank water tester
          if (testers.length && testers[0].key !== -1) {
            testers = [{key: -1, name: formatMessage({id: 'scanning.select.tester'})}].concat(testers);
          }
          // Let the default water tester be blank
          if (!a.id) {
            a.waterTester = formatMessage({id: 'scanning.select.tester'});
          }
          let workingCopy = a.clone();

          if (getResults()) {
            workingCopy = preprocessData(getResults(), workingCopy, this.state.selectedScanner, this.state.sanitizerType);
          }

          if (pool.winterMetalStaining) {
            events.publish('error.user', {
              message: formatMessage({id: 'scanning.last.offseason.winter'}),
              key: 'winterMetalStaining',
            });
          }

          branchApi.getBranch(customer.branchID)
            .then(branch => {
              let stripsAvailable = getStripsAvailable(productDict.sanitizer.currentName);

              this.setState({
                analysis: a,
                analysisWorkingCopy: workingCopy,
                branch: branch,
                customer: customer,
                dealer: dealer,
                loaded: true,
                pool: poolToSave,
                products: products,
                selectedDisc: discTypes(productDict.sanitizer.chemicalBaseType)[0],
                sanitizerName: productDict.sanitizer.currentName,
                sanitizerType: productDict.sanitizer.chemicalBaseType,
                stripsAvailable: stripsAvailable,
                selectedStrips: this.state.selectedStrips.length === 0 ? [stripsAvailable[0].key] : this.state.selectedStrips,
                testers: testers,
              });
            });
        };

        if (!isEqualWith(pool, p, (a, b) => {
          if (moment.isMoment(a) && moment.isMoment(b)) {
            return !a.isValid() && !b.isValid() || a.diff(b) === 0;
          }
        })) {

          let isSanitizerTruBlue = isProductTruBlue(products, productTypes.sanitizer, dealer, p.chemicalBaseTypeID, p.sanitizer);
          let isMaintOxidizerTruBlue = isProductTruBlue(products, productTypes.maintOxidizer, dealer, p.chemicalBaseTypeID, p.maintOxidizer);
          let isPrevAlgicideTruBlue = isProductTruBlue(products, productTypes.prevAlgicide, dealer, p.chemicalBaseTypeID, p.prevAlgicide);
          let isMaintClarifierTruBlue = isProductTruBlue(products, productTypes.maintClarifier, dealer, p.chemicalBaseTypeID, p.maintClarifier);

          p.hasAllTruBlueProducts = isSanitizerTruBlue && isMaintOxidizerTruBlue && isPrevAlgicideTruBlue && isMaintClarifierTruBlue;

          poolApi.savePool(p).then(savedPool => {
            saveToState(savedPool);
          });
        }

        saveToState(p);
      })
      .catch(err => {
        console.error(err);
        events.publish('error.user', {message: formatMessage({id: 'scanning.cannot.retrieve.data'})});
      });
  };

  getContactName = () => {
    let contact = null;
    let contactName = 'Customer';

    if (this.state.customer.customerContacts.length > 0) {
      contact = this.state.customer.customerContacts[0];

      for (let i = 0; i < this.state.customer.customerContacts.length; i++) {
        if (this.state.customer.customerContacts[i].id === this.props.contactId) {
          contact = this.state.customer.customerContacts[i];
        }
      }

      contactName = contact.nameFirst || contact.nameLast ? (contact.nameFirst || '') + ' ' + (contact.nameLast || '') : contact.organization;
    }

    return contactName;
  };

  focusElement = '';

  handleSocketError = () => {
    // Set loading icon for 15 seconds to give accuscan time to reset
    let scanResetCountdown = setInterval(() => {
      let delay = this.state.scanResetDelay - 1;

      if (delay <= 0) {
        clearTimeout(scanResetCountdown);
      }
      this.setState({scanResetDelay: delay});
    }, 1000);

    this.setState({
      isScanning: false,
      disabledFields: [],
      scanResetDelay: 30,
    });
  };

  initializeScanner = (preferManual = false) => {
    if (session.getUser().titrationTestingOnly) {
      this.setState({
        scannerInitialized: true,
        selectedScanner: 'Manual',
        selectedStrips: [],
        noScannersFound: false,
      });
    } else {
      getScanners()
        .then(data => {
          let disabledFields = [];

          if (isScanning()) {
            if (getCurrentScanner() === 'Accuscan') {
              disabledFields = scanDisabledFields.Accuscan[getAccuscanStrip()];
            } else if (getCurrentScanner() === 'SmartLab') {
              disabledFields = scanDisabledFields.SmartLab;
            }
          }

          let selectedScanner = getCurrentScanner() || data.scanners[0];

          let selectedStrips = getAccuscanStrips();

          if (selectedStrips.length === 0) {
            selectedStrips = this.state.selectedStrips;
          }

          this.setState({
            accuscanInstructions: selectedScanner === 'Accuscan' && !preferManual,
            disabledFields: disabledFields,
            manualScan: preferManual || selectedScanner === 'Manual',
            noScannersFound: data.scanners.length === 1,
            scannerInitialized: true,
            version: data.version,
            scanners: data.scanners,
            isScanning: isScanning(),
            securityError: undefined,
            selectedScanner: preferManual ? 'Manual' : selectedScanner,
            selectedStrips: selectedStrips,
          });

        })
        .catch(err => {
          this.setState({scannerInitialized: true});
        });
    }
  };

  isType = (types) => {
    return types.indexOf(this.state.sanitizerType) !== -1;
  };

  parseScanResults = (data) => {
    if (data) {
      let preprocessedData = preprocessData(data, this.state.analysisWorkingCopy, this.state.selectedScanner, this.state.sanitizerType);

      let historyId = new Date().getTime().toString();

      this.setState({
        disabledFields: [],
        isScanning: isScanning(),
        analysisWorkingCopy: preprocessedData,
        historyId: historyId,
      });

      storeHistory({
        id: historyId,
        name: this.getContactName(),
        scanner: this.state.selectedScanner,
        time: new Date(),
        analysis: data,
        data: {
          saved: false,
          state: this.state,
        },
      });
    }
    this.partialDrainCheck(this.state.analysisWorkingCopy); // Check drains after scanner
    if (this.state.selectedScanner === 'Accuscan' && getAccuscanStrips().length !== 0) {
      // Start next scan - Set loading icon for 15 seconds to give accuscan time to reset
      let scanResetCountdown = setInterval(() => {
        let delay = this.state.scanResetDelay;

        delay += -1;
        if (delay <= 0) {
          clearInterval(scanResetCountdown);
        }
        this.setState({scanResetDelay: delay});
      }, 1000);

      this.setState({scanResetDelay: 15});
    }

    setTimeout(() => {
      events.publish('testconnect.historyChanged');
    }, 1000);
  };

  saveAnalysis = (suggestedProducts = []) => {
    let {formatMessage} = this.props.intl;

    let analysis = this.state.analysisWorkingCopy;

    analysis.suggestedProducts = suggestedProducts.map(x => x.product);

    analysisApi.saveAnalysis(analysis)
      .then(a => {
        let pool = session.getPool(a.poolID);

        if (pool) {
          session.deletePool(pool);
        }

        session.forgetAnalysis(this.props.poolID);
        this.shouldPersist = false;

        resetTestConnect(!session.getUser().titrationTestingOnly);

        let locationHash;

        if (!this || !this.props || !this.props.analysisID) {
          locationHash = path.join(window.location.hash, 'report', a.id.toString());
        } else {
          locationHash = path.join(window.location.hash, '..', 'report', a.id.toString());
        }

        if (this.state.historyId) {
          updateHistory({
            id: this.state.historyId,
            data: {
              saved: true,
              url: locationHash,
            },
          });

          setTimeout(() => {
            events.publish('testconnect.historyChanged');
          }, 1000);
        }

        window.location.hash = locationHash;
      })
      .catch(e => {
        console.error(e);
        this.setState({saving: false});
        events.publish('error.user', {message: formatMessage({id: 'scanning.error.saving.analysis'})});
      });
    this.setState({saving: true});
  };

  scannerSettings = () => {
    let {formatMessage} = this.props.intl;

    if (this.state.manualScan) {
      return <div/>;
    }

    let runScan = () => {
      this.startScan(
        this.state.selectedScanner,
        this.state.selectedStrips,
        this.state.pool.chemicalBaseTypeID,
        this.state.selectedDisc
      );
    };

    if (!this.state.accuscanInstructions) {
      return (
        <div>
          <div className='row'>
            <div className='col-md-5'>
              <div className='form-group'>
                <label><FormattedMessage id='scanning.select.test.disk'/></label>
                <select className='form-control'
                        onChange={event => this.setState({selectedDisc: event.target.value})}>
                  {discTypes(this.state.sanitizerType).map(disc => <option key={disc} value={disc}>{disc}</option>)}
                </select>
              </div>
            </div>
            <div className='col-md-4'>
              <FormattedMessage id='scanning.close.lid.before'/>
            </div>
            <div className='col-md-3'>
              <div className='form-group'>
                <LoadingButton
                  className='btn btn-primary pull-right'
                  onClick={runScan}
                  loading={this.state.isScanning}
                  disabled={this.state.isScanning}>
                  {this.state.isScanning ? formatMessage({id: 'general.scan.in.progress'}) : formatMessage({id: 'general.start.scan'})}
                </LoadingButton>
              </div>
            </div>
          </div>
          <hr/>
        </div>
      );
    }

    let stripSelection;

    if (!this.state.isScanning) {
      stripSelection = this.state.scanResetDelay && this.state.scanResetDelay >= 0 ?
        <p>
          <scan className='b'><FormattedMessage id='scanning.reseting.accuscan'/></scan>
          {this.state.scanResetDelay} <FormattedMessage id='scanning.seconds.remaining'/></p> :
        this.state.stripsAvailable.map(strip => {
          return (
            <span key={strip.key}
                  className='b'
                  onClick={this.toggleTestStrip.bind(this, strip.key)}>
              <div className='checkbox-wrapper'>
                <input type='checkbox'
                       value={strip.key}
                       checked={this.state.selectedStrips.indexOf(strip.key) !== -1}/>
                <label/>
              </div>
              <span className='pointer'>{strip.label}</span>
            </span>
          );
        });
    } else {
      stripSelection =
        <div>
          {!this.state.scanResetDelay || this.state.scanResetDelay <= 0 ?
            <p><span className='b'>
              {stripTypes.find(s => s.key === this.state.selectedStrips[0]).label}
            </span> {formatMessage({id: 'general.scan.in.progress'}).toLowerCase()}...
            </p> : null}
          {this.state.scanResetDelay > 0 ? <p>
            <scan className='b'><FormattedMessage id='scanning.reseting.accuscan'/></scan>
            {this.state.scanResetDelay} <FormattedMessage id='scanning.seconds.remaining'/></p> : null}
          <p><FormattedMessage id='scanning.prepare.correct.test'/></p>
        </div>
      ;
    }

    return (
      <div>
        <div className='row'>
          <div className='col-xs-12'>
            <label><FormattedMessage id='scanning.scanner.settings'/></label>
            <div className='form-group'>
              {stripSelection}
              <LoadingButton
                className='btn btn-primary pull-right'
                onClick={runScan}
                loading={this.state.isScanning}
                disabled={this.state.isScanning || this.state.selectedStrips.length === 0}>
                <FormattedMessage id='general.start.scan'/>
              </LoadingButton>
            </div>
          </div>
        </div>
        <hr/>
      </div>
    );
  };

  shouldPersist = true;

  startScan = (selectedScanner, selectedStrips, chemicalBaseTypeID, selectedDisc) => {
    if (selectedScanner === 'Accuscan') {
      startAccuscan({chemicalBaseTypeID, strips: selectedStrips});
      this.setState({isScanning: true, disabledFields: scanDisabledFields.Accuscan[selectedStrips[0]]});
      events.publish('ga.event', {category: 'Scan', action: 'Accuscan'});
    } else {
      startSmartLab({chemicalBaseTypeID, disk: selectedDisc});
      this.setState({isScanning: true, disabledFields: scanDisabledFields.SmartLab});
      events.publish('ga.event', {category: 'Scan', action: 'Spin'});
    }

    window.scrollTo(0, 0);
  };

  toggleTestStrip = (key) => {
    let index = this.state.selectedStrips.indexOf(key);

    if (index === -1) {
      this.state.selectedStrips.push(key);
    } else {
      this.state.selectedStrips.splice(index, 1);
    }

    this.state.selectedStrips.sort((a, b) => {
      let stripValues = {
        Halogen: 0, Biguanide: 0,
        Copper: 1, Iron: 2,
      };

      return stripValues[a] - stripValues[b];
    });

    this.setState({selectedStrips: this.state.selectedStrips});
  };

  toggleValidation = (newState = false) => {
    this.setState({isValidating: newState});
  };

  updateFocusElement = (el, precedence = true) => {
    if (precedence || !this.focusElement && el) {
      this.focusElement = el;
    }
  };

  validateAnalysis = (e, ...args) => {
    this.toggleValidation(true);
    this.group.validate(e, ...args);
  };

  validateSeasonTemperatureOverrides = (analysis) => {
    const {country} = this.state.dealer;
    const temperatureOverrides = seasonTemperatureOverrides(country);

    if (analysis.season === seasonTypes.closing || analysis.season === seasonTypes.outSeason) {
      analysis.temperature = temperatureOverrides[analysis.season];
    } else if (this.state.analysisWorkingCopy) {
      let prevAnalysisSeason = this.state.analysisWorkingCopy.season;

      if (prevAnalysisSeason === seasonTypes.outSeason || prevAnalysisSeason === seasonTypes.closing) {
        //Wipe previous temperature overrides
        analysis.temperature = undefined;
      }
    }
    return analysis;
  };

  render() {
    if (this.state.securityError) {
      return (
        <div className='container'>
          <h3><FormattedMessage id='scanning.complete.water.test'/></h3>
          <br/>
          <p><a className='btn btn-default'
                href='#support/ie-security-error'><FormattedMessage
            id='general.click.troubleshoot'/></a></p>
        </div>
      );
    }

    let prevAlgicide = '';

    if (this.state.products.length > 0 && this.state.pool && this.state.pool.prevAlgicide) {
      let algicides = this.state.products.filter(x => x.id === this.state.pool.prevAlgicide);

      if (algicides.length > 0) {
        prevAlgicide = algicides[0].name;
      }
    }

    let pHBuffer = '';

    if (this.state.products.length > 0 && this.state.pool && this.state.pool.pHBuffer) {
      let buffers = this.state.products.filter(x => x.id === this.state.pool.pHBuffer);

      if (buffers.length > 0) {
        pHBuffer = buffers[0].name;
      }
    }

    let contactName = this.getContactName();

    //Generate customer id for url purpose
    let customerUrl = this.props.customerID.toString();

    if (!isNaN(this.props.contactId)) {
      customerUrl += '.' + this.props.contactId;
    }

    let subTitle = this.state.pool.softSoakTRIO ? 'Trio ' : '';

    subTitle += chemicalBaseTypeNames(this.state.pool.typeID, this.state.pool.chemicalBaseTypeID || 2, this.props.intl.formatMessage);
    let tagLine = this.state.pool.nickName ? this.state.pool.nickName : '';

    return (
      <div className='container scanning-page'>
        <Loader loaded={this.state.loaded}>
          <Header mainTitle={contactName}
                  subTitle={subTitle}
                  mainTitleReturn={'customer/' + customerUrl}
                  tagLine={tagLine}/>
          <AnalysisTabs
            systemPath={this.props.analysisID ? path.join(location.hash, '..', '..') : path.join(location.hash, '..')}/>
          <Popup
            onAccept={debounce(this.acceptPartialDrain, 750)}
            onDecline={this.declinePartialDrain}
            title='Drain and Refill'
            message={this.state.partialDrainMessage}
            visible={this.state.partialDrainVisible && !this.state.partialDrainAnswered}/>
          <WaterAnalysis
            accuscanInstructions={this.state.accuscanInstructions}
            analysis={this.state.analysisWorkingCopy}
            branch={this.state.branch}
            changeScanner={this.changeScanner}
            customer={this.state.customer}
            dataChanged={this.dataChanged}
            dealer={this.state.dealer}
            disabledFields={this.state.disabledFields}
            edit={this.state.edit}
            group={this.group}
            handshakeComplete={this.state.scannerInitialized}
            isType={this.isType}
            noScannersFound={this.state.noScannersFound}
            pHBuffer={pHBuffer}
            pool={this.state.pool}
            prevAlgicide={prevAlgicide}
            products={this.state.products}
            sanitizerName={this.state.sanitizerName}
            sanitizerType={this.state.sanitizerType || 0}
            isScanning={this.state.isScanning}
            scanners={this.state.scanners}
            version={this.state.version}
            scannerSettings={this.scannerSettings}
            selectedScanner={this.state.selectedScanner}
            selectedStrips={this.state.selectedStrips}
            testers={this.state.testers}
            updateFocusElement={this.updateFocusElement}/>
          <WaterProblems
            analysis={this.state.analysisWorkingCopy}
            dealer={this.state.dealer}
            dataChanged={this.dataChanged}
            edit={this.state.edit}
            group={this.group}
            isType={this.isType}
            pool={this.state.pool}
            updateFocusElement={this.updateFocusElement}/>

          <SuggestedProductsSelection chemicalBaseTypeID={this.state.sanitizerType}
                                      dealer={this.state.dealer}
                                      analysis={this.state.analysisWorkingCopy}
                                      saving={this.state.saving}
                                      saveAnalysis={this.validateAnalysis}
                                      isScanning={this.state.isScanning}
                                      isValidating={this.state.isValidating} />
        </Loader>
      </div>
    );
  }
}

const WrapperScanning = injectIntl(Scanning);

export default Scanning;
